export enum AuthStatus {
    'Idle',
    'LoggedOut',
    'SessionExpired',
}
